module.exports = __webpack_public_path__ + "img/export-running-profile.9aeef254.svg";